/**
 * The current status of the monitor
 * Shared F/E and API enum
 */
export enum ViMonitorStatusEnum {
    active = 'ACTIVE',
    paused = 'PAUSED',
    draft = 'DRAFT',
}
